import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

// Evita la "pantalla en blanco": cualquier error de render muestra esta pantalla con opción de recargar.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-6 text-center" data-testid="error-boundary">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-vino-50 text-vino-700">
            <AlertTriangle className="h-7 w-7" />
          </div>
          <div>
            <h1 className="font-display text-xl font-bold text-slate-900">Algo salió mal al mostrar esta pantalla</h1>
            <p className="mt-1 max-w-md text-sm text-slate-500">
              Sus datos están a salvo. Recargue la página; si el problema continúa, informe a HUMAN.
            </p>
          </div>
          <button
            onClick={() => window.location.reload()}
            data-testid="btn-recargar-error"
            className="flex items-center gap-2 rounded-lg bg-vino-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-vino-800"
          >
            <RefreshCw className="h-4 w-4" /> Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
